var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { Modal } from 'antd';
import Iframe from 'react-iframe';
import YoutubeVideoCrossIcon from '../assets/svgIcons/YoutubeVideoCrossIcon';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var defaultProps = {
    videoLink: '',
    visible: false,
    setVisible: {},
};
var VideoPopup = function VideoPopup(props) {
    var visible = props.visible, videoLink = props.videoLink, setVisible = props.setVisible;
    return (_jsx(Wrapper, __assign({ className: "popup_wrapper" }, { children: _jsx(Modal, __assign({ open: visible, onCancel: setVisible, centered: true, destroyOnClose: true, maskClosable: true, width: 854, getContainer: "", closeIcon: _jsx("div", __assign({ className: "cross-icon-x" }, { children: _jsx(YoutubeVideoCrossIcon, {}) })), wrapClassName: "video-popup-wrapper" }, { children: _jsx(Iframe, { url: videoLink, width: "100%", height: "100%", id: "videoFrameId", className: "videoFrame", display: "block", position: "relative", scrolling: "no", frameBorder: 0 }) })) })));
};
VideoPopup.defaultProps = defaultProps;
export default VideoPopup;
var templateObject_1;
